<template>
    <div class="m-1">
          <div 
              v-for="(liga, index) in ligas"
              v-bind:key="index"
          >  
              <div v-if="!collapsed_leagues.includes(liga.id)">
                  <div v-if="screen_width>skin.break_point">
                    <div v-if="liga.sport==1 && show_header">
                        <div class="px-3">
                            <Futbol
                                :Skin="skin"
                                :translation="translation"
                                :language="language"
                            ></Futbol>
                        </div>
                    </div>
                    <div v-else-if="liga.sport==76||liga.sport==29||liga.sport==37 && show_header">
                        <div class="px-3">
                            <Rugby
                                :Skin="skin"
                                :translation="translation"
                                :language="language"
                            ></Rugby>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="show_header" class="px-3">
                            <Cricket
                                :Skin="skin"
                                :translation="translation"
                                :language="language"
                            ></Cricket>
                        </div>
                    </div>
                  </div>
                  <div v-if="liga.events.length>0">
                      <encuentro v-for="game in liga.events"
                      v-bind:game="game"
                      v-bind:sport="liga.sport"
                      v-bind:Skin="skin"
                      v-bind:key="game.id"
                      v-bind:language="language"
                      v-bind:translation="translation"
                  />
                  </div>
              </div>
          </div>
    </div>
  </template>
  
  <script>
  import navigationBar from './navigation/navigation_bar.vue';
  import encuentro from '../main_lobby/main_events_prematch2/Encuentro.vue';
  import Futbol from '../main_lobby/sport_tables/futbol.vue';
  import Cricket from '../main_lobby/sport_tables/cricket.vue';
  import Rugby from '../main_lobby/sport_tables/rugby.vue';
  import Tenis from '../main_lobby/sport_tables/tenis.vue';
  import Balonmano from '../main_lobby/sport_tables/balonmano.vue';
  const flags = require('../../../assets/countries.json');
  export default {
      name:"ligas_prematch3",
      props:["skin","translation","language"],
      components:{
          navigationBar,
          encuentro,
          Futbol,
          Cricket,
          Rugby,
          Tenis,
          Balonmano
      }, 
      data(){
          return{
              collapsed_leagues:[],
              show_header:true
          }
      },
      computed:{
          ligas_array(){
              let data = this.$store.getters['prematch_2/getLigasArray'];
              if([...data].length<1){
                  this.$store.dispatch('setLobbyView','main');
              }
              return data;
          },
          ligas(){
              let ligas = [];
              let data = this.$store.getters['prematch_2/getSports'];
              let regions_banned = this.$store.getters['getConfig'].SkinConfig.main.hideRegionsPrematch;
              let words_banned = this.$store.getters['getConfig'].SkinConfig.main.hideWords;
              let ligas_banned = this.$store.getters['getConfig'].SkinConfig.main.hideCompetitionsPrematch;
              this.ligas_array.forEach(target_league=>{
                  Object.keys(data).forEach(sport=>{
                      Object.keys(data[sport].region).forEach(pais=>{
                          if(data[sport].region[pais] ? (target_league.country == data[sport].region[pais].id ? true : false) : false){
                              if(!regions_banned.includes(data[sport].region[pais].alias)){
                                  if(data[sport].region[pais].competition){
                                      Object.keys(data[sport].region[pais].competition).forEach(liga=>{
                                          if(target_league.league == data[sport].region[pais].competition[liga].id){
                                              data[sport].region[pais].competition[liga].sport = data[sport].id;
                                              data[sport].region[pais].competition[liga].sport_alias = data[sport].alias;
                                              data[sport].region[pais].competition[liga].sport_name = data[sport].name;
                                              data[sport].region[pais].competition[liga].country = data[sport].region[pais].name;
                                              data[sport].region[pais].competition[liga].country_alias = data[sport].region[pais].alias;
                                              data[sport].region[pais].competition[liga].country_id = data[sport].region[pais].id;
                                              data[sport].region[pais].competition[liga].events = [];
                                              ligas.push(data[sport].region[pais].competition[liga]);
                                          }
                                      });
                                  }
                              }
                          }
                      });
                  });
              })
              ligas.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
              ligas.forEach(liga=>{
                  if((liga ? (liga.game ? true : false) : false)){
                      Object.keys(liga.game).forEach(element=>{
                          if(liga.game[element]){
                              if(liga.game[element] && liga.game[element].info && !liga.game[element].favorite){
                                  let banned = false;
                                  words_banned.forEach(word => {
                                      if(liga.game[element].team1_name){
                                          if(liga.game[element].team1_name.includes(word)){
                                              banned = true;
                                          }
                                      }
                                      if(liga.game[element].team2_name){
                                          if(liga.game[element].team2_name.includes(word)){
                                              banned = true;
                                          }
                                      }            
                                  });
                                  ligas_banned.forEach(word => {
                                      if(liga.name){
                                          if(liga.name.includes(word)){
                                              banned = true;
                                          }
                                      }           
                                  });
                                  if(!liga.game[element].team2_name){
                                      this.show_header=false
                                  }
                                  if(!banned && liga.game[element].market){
                                      liga.game[element].liga = liga.name;
                                      liga.game[element].liga_id = liga.id;
                                      liga.game[element].sport = liga.sport;
                                      liga.game[element].sport_id = liga.sport;
                                      liga.game[element].country = liga.country;
                                      liga.game[element].country_alias = liga.country_alias;
                                      liga.game[element].country_id = liga.country_id;
                                      liga.game[element].sport_alias = liga.sport_alias;
                                      liga.events.push(liga.game[element]);
                                  }
                              }  
                          } 
                      });
                      liga.events.sort((a,b) => (a.start_ts > b.start_ts) ? 1 : ((b.start_ts > a.start_ts) ? -1 : 0))
                  }
              });
              return ligas; 
          },
          navigation(){
              let links = [];
              let sports = {};
              let countries = {};
              let leagues = {};
              let data = this.$store.getters['prematch_2/getLigasArray'];
              data.forEach(liga => {
                  sports[liga.sport_id] = liga.sport_name.toUpperCase();
                  countries[liga.country] = liga.country_name.toUpperCase();
                  leagues[liga.league] = liga.league_name.toUpperCase();
              });
              if(Object.keys(leagues).length == 1 && Object.keys(sports).length == 1 && Object.keys(countries).length == 1){
                  links.push({
                      name:sports[Object.keys(sports)[0]],
                      link:""
                  });
                  links.push({
                      name:this.$props.translation['competitions'][this.$props.language],
                      link:""
                  });
                  links.push({
                      name:countries[Object.keys(countries)[0]],
                      link:""
                  });
                  links.push({
                      name:leagues[Object.keys(leagues)[0]],
                      link:""
                  });
              }
              else if(Object.keys(sports).length > 1){
                  links.push({
                      name:this.$props.translation['competitions'][this.$props.language],
                      link:""
                  });
              }
              else if(Object.keys(countries).length > 1 && Object.keys(countries).length < 4 && Object.keys(sports).length == 1){
                  links.push({
                      name:sports[Object.keys(sports)[0]],
                      link:""
                  });
                  links.push({
                      name:this.$props.translation['competitions'][this.$props.language],
                      link:""
                  });
                  let countries_str = []
                  Object.keys(countries).forEach(country => {
                      countries_str.push(countries[country]);
                  });
                  links.push({
                      name:countries_str.join(" - "),
                      link:""
                  });
              }
              else if(Object.keys(countries).length == 1 && Object.keys(sports).length == 1 && Object.keys(leagues).length > 1){
                  links.push({
                      name:sports[Object.keys(sports)[0]],
                      link:""
                  });
                  links.push({
                      name:this.$props.translation['competitions'][this.$props.language],
                      link:""
                  });
                  links.push({
                      name:countries[Object.keys(countries)[0]],
                      link:""
                  });
              }
              else{
                  links.push({
                      name:this.$props.translation['competitions'][this.$props.language],
                      link:""
                  });
              }
              return links;
          }
      },
      methods:{
          country_flag(name) {
              let flag = []
              flags.countries.forEach(country => {
                  if(country.name_es == name){
                      flag.push(country.code.toLowerCase());
                  }
              });
              return flag;
          },
          hide_show_liga(liga){
              if(!this.collapsed_leagues.includes(liga)){
                  this.collapsed_leagues.push(liga);
              }
              else{
                  this.collapsed_leagues.splice(this.collapsed_leagues.indexOf(liga),1);
              }
          },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                  return this.$props.translation[text][this.$props.language];
                  }
                  else{
                  var new_text_serched = text.replace(/ /g, "_");
                  if (this.$props.translation[new_text_serched]) {
                      return this.$props.translation[new_text_serched][this.$props.language];
                  }
                  }
                  return text;
              }
          },
          sizeControl(){
            this.screen_width=window.innerWidth;
        },
      },
        mounted() {
            window.addEventListener('resize', ()=>{this.sizeControl();});
        },
        created(){
            this.sizeControl();
        }
  }
  </script>
  
  <style>
  
  </style>